import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="w-full px-4 md:px-8 pt-6">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {idx < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}